<template>
  <div class="flex items-start space-x-3">
    <div class="flex-shrink-0 text-gray-400">
      <slot name="icon" />
    </div>
    <div class="text-sm leading-5 text-slate-800">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoRow"
};
</script>
